import { TableHeadersType } from "../../../constant/tableHeadersConstants/tableHeadersType";
import { ClientWiseMonthlyTimesheetType } from "../../../redux/timeSheet/timeSheetType";
type AppProps = {
  data: ClientWiseMonthlyTimesheetType[] | [];
  tableHeader: TableHeadersType[];
};
const TimesheetClientWiseMonthlyReportTableData = ({
  data,
  tableHeader,
}: AppProps) => {
  return (
    <>
      {data &&
        data?.length > 0 &&
        data?.map((itemData: any) => {
          return (
            <tr key={itemData?._id}>
              {tableHeader?.map((item: TableHeadersType) => {
                if (item?.value === "month") {
                  return <td>{`${itemData?.month} - ${itemData?.year}`}</td>;
                } else if (item?.value == "total_hours_charged") {
                  return <td>{itemData?.total_hours_charged}</td>;
                }
              })}
            </tr>
          );
        })}
    </>
  );
};

export default TimesheetClientWiseMonthlyReportTableData;
